export interface EnvConfig {
    API?: string;
    ENV?: string;
    DEBUG?: boolean;
}

export const ENV_CONFIG: EnvConfig = {DEBUG: true};
